import { registerLocale } from '@modules/core/utils';
import { TranslateService } from '@ngx-translate/core';

export function LanguageFactory(translate: TranslateService) {
  return () => {
    const languages = ['de', 'en', 'fr', 'it', 'es', 'pt'];
    const browserLanguage = translate.getBrowserLang() as string;
    const activeLang = languages.indexOf(browserLanguage) !== -1 ? browserLanguage : languages[0];

    translate.addLangs(languages);
    translate.use(activeLang);
    registerLocale(activeLang);
  }
}
